import type { IDashboardCondominiumRepository } from '@yawi/domain';
import type {
  AccessTodaySummary,
  ChargeSummaryExtended,
  ChargesHistoryResponse,
  ChargingAgingResponse,
  DashboardActivityResponse,
  DashboardAlertsResponse,
  DashboardInsight,
  DashboardKpisResponse,
  UpcomingExpensesResponse,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

export class ApiDashboardCondominiumRepository implements IDashboardCondominiumRepository {
  async getInsight(): Promise<DashboardInsight> {
    return getApiClient().get<DashboardInsight>('v1/dashboard/insight');
  }

  async getAlerts(limit = 3): Promise<DashboardAlertsResponse> {
    return getApiClient().get<DashboardAlertsResponse>(`v1/dashboard/alerts?limit=${limit}`);
  }

  async getActivity(limit = 4, excludeAccess = false): Promise<DashboardActivityResponse> {
    const qs = excludeAccess ? '&excludeAccess=true' : '';
    return getApiClient().get<DashboardActivityResponse>(`v1/dashboard/activity?limit=${limit}${qs}`);
  }

  async getKpis(period?: string): Promise<DashboardKpisResponse> {
    const qs = period ? `?period=${period}` : '';
    return getApiClient().get<DashboardKpisResponse>(`v1/dashboard/kpis${qs}`);
  }

  async getChargesSummary(period?: string): Promise<ChargeSummaryExtended> {
    const qs = period ? `?period=${period}` : '';
    return getApiClient().get<ChargeSummaryExtended>(`v1/charges/summary${qs}`);
  }

  async getChargesAging(period?: string): Promise<ChargingAgingResponse> {
    const qs = period ? `?period=${period}` : '';
    return getApiClient().get<ChargingAgingResponse>(`v1/charges/aging${qs}`);
  }

  async getChargesHistory(months = 8): Promise<ChargesHistoryResponse> {
    return getApiClient().get<ChargesHistoryResponse>(`v1/charges/history?months=${months}`);
  }

  async getUpcomingExpenses(limit = 4): Promise<UpcomingExpensesResponse> {
    return getApiClient().get<UpcomingExpensesResponse>(`v1/expenses/upcoming?limit=${limit}`);
  }

  async getAccessTodaySummary(): Promise<AccessTodaySummary> {
    return getApiClient().get<AccessTodaySummary>('v1/access-logs/today-summary');
  }
}
